import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from "../../lib/utils";
import {
    LayoutDashboard,
    FolderCog,
    Bell,
    Users,
    FileText,
    Download,
    ArrowLeft,
    LogOut
} from 'lucide-react';
import { Button } from "../ui/button";

const MENU_ITEMS = [
    { label: 'Indicator Alert', icon: LayoutDashboard, path: '/admin/indicator-alerts' },
    { label: 'Manage Folders', icon: FolderCog, path: '/admin/folders' },
    { label: 'All Alerts', icon: Bell, path: '/admin/alerts' },
    { label: 'User', icon: Users, path: '/admin/users' },
    { label: 'Terms And Conditions', icon: FileText, path: '/admin/terms' },
    { label: 'Alert Receiver', icon: Download, path: '/admin/receiver' },
];

export function AdminSidebar() {
    const location = useLocation();

    return (
        <div className="w-64 h-screen bg-slate-950 border-r border-slate-800 flex flex-col shrink-0">
            {/* Header / Logo Area */}
            <div className="p-6 border-b border-slate-800/50">
                <div className="flex items-center gap-3">
                    {/* Mock Logo Icon based on L2T */}
                    <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-cyan-400 flex items-center justify-center shrink-0">
                        <LayoutDashboard className="w-5 h-5 text-white" />
                    </div>
                    <div>
                        <h1 className="font-bold text-white text-lg leading-none">
                            <span className="text-blue-400">L2T</span> Admin
                        </h1>
                        <p className="text-xs text-slate-500 mt-1">Trading System Control</p>
                    </div>
                </div>
            </div>

            {/* Menu Items */}
            <div className="flex-1 overflow-y-auto py-6 px-3 space-y-1">
                {MENU_ITEMS.map((item) => {
                    const isActive = location.pathname === item.path;
                    return (
                        <Link key={item.path} to={item.path}>
                            <div
                                className={cn(
                                    "flex items-center gap-3 px-3 py-3 rounded-xl transition-all duration-200 group",
                                    isActive
                                        ? "bg-emerald-900/30 text-emerald-400"
                                        : "text-slate-400 hover:text-white hover:bg-slate-800/50"
                                )}
                            >
                                <item.icon className={cn(
                                    "w-5 h-5 transition-colors",
                                    isActive ? "text-emerald-400" : "text-slate-500 group-hover:text-white"
                                )} />
                                <span className="font-medium">{item.label}</span>
                            </div>
                        </Link>
                    );
                })}
            </div>

            {/* Footer Actions */}
            <div className="p-4 border-t border-slate-800/50 space-y-3">
                {/* Back to Main Dashboard */}
                <Link to="/admin/dashboard">
                    <div className="flex items-center gap-3 px-4 py-3 rounded-xl border border-slate-700/50 bg-slate-900/50 hover:bg-slate-800 transition-colors cursor-pointer group">
                        <ArrowLeft className="w-4 h-4 text-slate-500 group-hover:text-white" />
                        <div className="flex flex-col">
                            <span className="text-sm font-medium text-slate-300 group-hover:text-white">Back to Dashboard</span>
                        </div>
                    </div>
                </Link>
            </div>
        </div>
    );
}

export default function AdminLayout({ children }) {
    return (
        <div className="flex h-screen w-full bg-slate-950 overflow-hidden">
            <AdminSidebar />
            <div className="flex-1 overflow-auto bg-slate-900">
                {children}
            </div>
        </div>
    );
}
